export const COMMISSION_STATUS = {
  PENDING_PAYMENT: 'pending_payment',
  PENDING_RELEASE: 'pending_release',
  RELEASED: 'released',
  PAID: 'paid',
  CANCELLED: 'cancelled',
};

export const COMMISSION_STATUS_META = {
  [COMMISSION_STATUS.PENDING_PAYMENT]: {
    label: 'Pendente Pagamento',
    color: 'warning',
  },
  [COMMISSION_STATUS.PENDING_RELEASE]: {
    label: 'A Liberar',
    color: 'info',
  },
  [COMMISSION_STATUS.RELEASED]: {
    label: 'Liberado',
    color: 'primary',
  },
  [COMMISSION_STATUS.PAID]: {
    label: 'Pago',
    color: 'success',
  },
  [COMMISSION_STATUS.CANCELLED]: {
    label: 'Cancelado',
    color: 'error',
  },
};

export const COMMISSION_STATUS_OPTIONS = [
  { value: COMMISSION_STATUS.PENDING_PAYMENT, label: 'Pendente Pagamento' },
  { value: COMMISSION_STATUS.PENDING_RELEASE, label: 'A Liberar' },
  { value: COMMISSION_STATUS.RELEASED, label: 'Liberado' },
  { value: COMMISSION_STATUS.PAID, label: 'Pago' },
  { value: COMMISSION_STATUS.CANCELLED, label: 'Cancelado' },
];

export function getStatusLabel(status) {
  const meta = COMMISSION_STATUS_META[status];
  return meta ? meta.label : status;
}

export function getStatusColor(status) {
  const meta = COMMISSION_STATUS_META[status];
  return meta ? meta.color : 'default';
}
